import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../api.service';
import { Card, Category, Formula, Product } from '../../models';
@Injectable({
  providedIn: 'root',
})
export class MenuDataService {
  isMock = environment.mock;
  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) {}

  getCards(shopId: string, serviceDate: string): Observable<Card[]> {
    if (this.isMock) {
      return this.http
        .get<Card[]>('./assets/mocks/cards.json')
        .pipe(catchError((err) => throwError(err)));
    }
    return this.apiService
      .get(
        `shops/${shopId}/service-dates/${serviceDate}/cards`,
        new HttpParams(),
        new HttpHeaders()
      )
      .pipe(catchError((err) => throwError(err)));
  }

  getCategories(shopId: string, serviceDate: string): Observable<Category[]> {
    if (this.isMock) {
      return this.http
        .get<Category[]>('./assets/mocks/categories.json')
        .pipe(catchError((err) => throwError(err)));
    }
    return this.apiService
      .get(
        `shops/${shopId}/service-dates/${serviceDate}/categories`,
        new HttpParams(),
        new HttpHeaders()
      )
      .pipe(catchError((err) => throwError(err)));
  }

  getProducts(
    shopId: string,
    serviceDate: string,
    cardId: string
  ): Observable<Product[]> {
    if (this.isMock) {
      return this.http
        .get<Product[]>('./assets/mocks/products.json')
        .pipe(catchError((err) => throwError(err)));
    }
    return this.apiService
      .get(
        `shops/${shopId}/service-dates/${serviceDate}/products?card-id=${cardId}`,
        new HttpParams(),
        new HttpHeaders()
      )
      .pipe(catchError((err) => throwError(err)));
  }

  getFormulas(shopId: string, serviceDate: string): Observable<Formula[]> {
    if (this.isMock) {
      return this.http
        .get<Formula[]>('./assets/mocks/formules.json')
        .pipe(catchError((err) => throwError(err)));
    }
    return this.apiService
      .get(
        `shops/${shopId}/service-dates/${serviceDate}/formulas`,
        new HttpParams(),
        new HttpHeaders()
      )
      .pipe(catchError((err) => throwError(err)));
  }
}
